module.exports = __webpack_public_path__ + "static/media/share.44838f89.png";